import uuid from 'uuid/v4';
import { DropTarget as reactDropTarget } from 'react-dnd';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import DnDItemTypes from '../DynamicDnD/DnDItemTypes';
import DraggableDefinitionAnswer from '../DynamicTree/DraggableDefinitionAnswer';

const dropTarget = {
  canDrop: props =>
    props.selectedDefinition &&
    (props.selectedDefinition.scope === 4 ||
      props.selectedDefinition.scope === 5),

  drop(props, monitor) {
    props.handleTargetDrop(
      monitor.getItem().selectedEntries.map(entry => ({
        id: 0,
        name: entry.title,
        expression: entry.keyword,
      })),
    );
  },
};

function collect(connect, monitor) {
  return {
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver(),
    canDrop: monitor.canDrop(),
  };
}

class DefinitionTarget extends Component {
  static sortBy(field, reverse, primer) {
    const key = primer ? x => primer(x[field]) : x => x[field];
    const sortOrder = !reverse ? 1 : -1;

    return (a, b) => {
      const x = key(a);
      const y = key(b);
      return sortOrder * ((x > y) - (y > x));
    };
  }
  constructor(props) {
    super(props);
    this.state = {
      targetData: [],
      selectedTargets: [],
      sortOrder: '',
      sortOrderIcon: '',
    };
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    this.setState({
      targetData: nextProps.targetData,
      selectedTargets: [],
      sortOrder: '',
      sortOrderIcon: '',
    });
    this.targets = nextProps.targetData.map(item => item.expressionId);
  }
  getSelectedTargets = () =>
    this.props.targetData.filter(
      target => this.state.selectedTargets.indexOf(target.expressionId) > -1,
    );

  handleSort = () => {
    let sortOrder;
    let sortOrderIcon;
    const sortedData = [...this.props.targetData];
    if (this.state.sortOrder === 'DESC') {
      sortOrder = 'ASC';
      sortOrderIcon = 'node-icon-arrow-up';
    } else {
      sortOrder = 'DESC';
      sortOrderIcon = 'node-icon-arrow-down';
    }
    sortedData.sort(
      this.constructor.sortBy('title', sortOrder === 'DESC', value =>
        value.toUpperCase(),
      ),
    );
    this.setState({ targetData: sortedData, sortOrder, sortOrderIcon });
    this.targets = sortedData.map(item => item.expressionId);
  };

  handleMouseDown = (e, expressionId) => {
    if (
      e.button === 0 &&
      !e.ctrlKey &&
      !e.shiftKey &&
      this.state.selectedTargets.indexOf(expressionId) < 0
    ) {
      this.setState({ selectedTargets: [expressionId] });
    }
  };

  handleMouseUp = (e, expressionId) => {
    if (e.button === 0) {
      if (e.ctrlKey) {
        if (this.state.selectedTargets.indexOf(expressionId) !== -1) {
          return this.setState({
            selectedTargets: this.state.selectedTargets.filter(
              item => item !== expressionId,
            ),
          });
        }
        return this.setState({
          selectedTargets: [...this.state.selectedTargets, expressionId],
        });
      }

      if (
        e.shiftKey &&
        this.state.selectedTargets.length !== 0 &&
        this.state.selectedTargets[0] !== expressionId
      ) {
        const baseTarget = this.state.selectedTargets[0];
        if (
          this.targets.indexOf(baseTarget) < this.targets.indexOf(expressionId)
        ) {
          return this.setState({
            selectedTargets: this.targets.slice(
              this.targets.indexOf(baseTarget),
              this.targets.indexOf(expressionId) + 1,
            ),
          });
        }

        const reverseTargets = this.targets.slice().reverse();
        return this.setState({
          selectedTargets: reverseTargets.slice(
            reverseTargets.indexOf(baseTarget),
            reverseTargets.indexOf(expressionId) + 1,
          ),
        });
      }
      return this.setState({ selectedTargets: [expressionId] });
    }

    return undefined;
  };

  renderTargetItems = () =>
    this.state.targetData.map(item => (
      <div
        className={`titlebox  ${
          this.state.selectedTargets.indexOf(item.expressionId) !== -1
            ? 'selected'
            : ''
        }`}
        key={item.expressionId}
        data-tooltip
        aria-haspopup="true"
        title={item.title}
        onMouseUp={e => this.handleMouseUp(e, item.expressionId)}
        onMouseDown={e => this.handleMouseDown(e, item.expressionId)}
      >
        <DraggableDefinitionAnswer
          name={item.title.toUpperCase()}
          handleAnswersPreview={this.props.handleAnswersPreview}
          getSelectedTargets={this.getSelectedTargets}
        />
      </div>
    ));

  renderTargetEmpty = () => {
    const emptyElemArray = [];
    let remainingNum = 12 - this.state.targetData.length;
    for (; remainingNum > 0; remainingNum -= 1) {
      emptyElemArray.push(<div className="titlebox empty" key={uuid()} />);
    }
    return emptyElemArray;
  };

  render() {
    const { connectDropTarget, isOver, canDrop } = this.props;

    return connectDropTarget(
      <div className="definition-grid">
        <div className={canDrop && isOver ? 'droppable' : ''}>
          <div className="titlebar" onClick={this.handleSort}>
            Title
            <span className={this.state.sortOrderIcon} />
          </div>
          <div className="titlebox-wrapper">
            {this.renderTargetItems()}
            {this.renderTargetEmpty()}
          </div>
        </div>
      </div>,
    );
  }
}

DefinitionTarget.propTypes = {
  connectDropTarget: PropTypes.func,
  isOver: PropTypes.bool,
  canDrop: PropTypes.bool,
  handleAnswersPreview: PropTypes.func,
  targetData: PropTypes.arrayOf(PropTypes.shape({})),
};

export default reactDropTarget([DnDItemTypes.DnD_ITEM_TYPE_3], dropTarget, collect)(
  DefinitionTarget,
);
